<app-header-profile></app-header-profile>
<router-outlet></router-outlet>
<app-footer></app-footer>
